import { GzFormFieldWebComponent } from '../../gzForm/formField';
import { styles } from '../view/styles';
import { LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { GzButtonWebComponent } from '../../gzButton';
import { GzInputWebComponent } from '../../gzInput/component/GzInputWebComponent';
import { ifDefined } from 'lit/directives/if-defined.js';

export class GzDynamicFormInputWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({ type: Boolean, reflect: true, attribute: true })
  public isClearable = false;

  @property({ type: Boolean, reflect: true, attribute: true })
  public disabled = false;

  @property({ type: String, reflect: true, attribute: true })
  public value: null | string = null;

  @query('#delete')
  private deleteBtn: GzButtonWebComponent;

  @query('gz-form-field')
  formField: GzFormFieldWebComponent<GzInputWebComponent, string>;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  connectedCallback() {
    super.connectedCallback();

    this.updateComplete.then(() => {
      this.emitCreatedEvent();
    });
  }

  render() {
    return html`
      <div class="dynamic-input">
        <gz-form-field required>
          <gz-input gz-form-input type="text" .value="${ifDefined(this.value)}"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-icon-button
          fontSize="24"
          size="32"
          buttonColor="secondary"
          buttonFill="quiet"
          icon="ds-icon-delete_large"
          id="delete"
          class="${this.isClearable ? '' : 'hidden'}"
          @click="${this.deleteItem}"
        ></gz-icon-button>
      </div>
    `;
  }

  deleteItem() {
    const event = new CustomEvent('delete', {
      detail: {
        itemId: this.getAttribute('id'),
      },
    });
    this.dispatchEvent(event);
  }

  emitCreatedEvent() {
    const event = new CustomEvent('created', {
      detail: {
        itemId: this.getAttribute('id'),
      },
      composed: true,
    });
    this.dispatchEvent(event);
  }
}
